import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const CurvIcon = ({
  width = 48,
  marginLeft,
  marginRight,
  color = 'foraBlue',
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <path id="prefix__a" d="M0 43.799L65.231 43.799 65.231 0 0 0z" />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(7 25.5)">
        <path
          fill={getSemanticTextColor(color)}
          d="M2.53 32.931l7.106-.94c.847 1.726 2.602 2.925 4.654 2.925 2.87 0 5.195-2.325 5.195-5.197 0-.576-.116-1.123-.29-1.641l5.252-3.963c.813.526 1.774.839 2.814.839 1.878 0 3.508-1.005 4.42-2.5l5.13.957c.267 2.62 2.453 4.669 5.144 4.669 2.869 0 5.196-2.327 5.196-5.197 0-1.292-.49-2.461-1.271-3.372l4.898-7.94c.384.09.776.148 1.186.148 2.869 0 5.196-2.325 5.196-5.194 0-.095-.023-.181-.028-.274l8.099-3.196L64.026.001l-8.102 3.196c-.952-1.135-2.363-1.87-3.96-1.87-2.87 0-5.195 2.326-5.195 5.198 0 1.264.47 2.41 1.22 3.311l-4.92 7.978c-.36-.079-.732-.127-1.114-.127-1.885 0-3.52 1.012-4.43 2.515l-5.12-.952c-.258-2.629-2.448-4.69-5.144-4.69-2.872 0-5.197 2.328-5.197 5.197 0 .632.13 1.23.336 1.79l-5.166 3.898c-.839-.58-1.85-.922-2.944-.922-2.533 0-4.638 1.815-5.1 4.212l-7.09.94.43 3.256z"
        />
        <path
          xmlns="http://www.w3.org/2000/svg"
          fill={getSemanticTextColor(color)}
          d="M0 43.799L64.787 43.799 64.787 40.149 0 40.149z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
